import { QueryClient } from '@tanstack/react-query';

export const queryKeys = {
  session: ['session'] as const,
  publicConfig: ['public-config'] as const,
  entitlements: (userId: string) => ['account-entitlements', userId] as const,
  dashboard: ['dashboard'] as const,
  profile: ['career-profile'] as const,
  resumes: ['resumes'] as const,
  linkedin: ['linkedin'] as const,
  jobs: ['jobs'] as const,
  interviews: ['interviews'] as const,
};

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 10 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
